/* Password visibility stays local to its input and resets with its form. */
(function () {
  "use strict";
  document.querySelectorAll('input[type="password"]').forEach((input, index) => {
    if (!input.id) input.id = `password-field-${index}`;
    const caption = input.closest("label")?.querySelector(":scope > span");
    if (caption && !input.hasAttribute("aria-labelledby") && !input.hasAttribute("aria-label")) {
      // The reveal button sits inside the implicit label; its changing action
      // must not become part of the password field's own accessible name.
      if (!caption.id) caption.id = `${input.id}-label`;
      input.setAttribute("aria-labelledby", caption.id);
    }
    const wrapper = document.createElement("span");
    wrapper.className = "password-input";
    input.replaceWith(wrapper);
    wrapper.append(input);
    const button = document.createElement("button");
    button.type = "button";
    button.className = "password-eye";
    button.setAttribute("aria-controls", input.id);
    button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><g data-eye-open><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></g><g data-eye-closed><path d="M3 8s3 6 9 6 9-6 9-6M5 11l-2 3m6-1-1 4m7-4 1 4m3-6 2 3"/></g></svg>';
    function setVisible(visible) {
      input.type = visible ? "text" : "password";
      button.setAttribute("aria-label", visible ? "Hide password" : "Show password");
      button.setAttribute("aria-pressed", String(visible));
    }
    button.addEventListener("click", event => {
      event.preventDefault();
      if (!input.disabled) setVisible(input.type === "password");
    });
    input.form?.addEventListener("reset", () => setVisible(false));
    wrapper.append(button);
    setVisible(false);
  });
})();
